<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" icon="el-icon-plus" @click="add">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :allBtnWidth="allBtnWidth" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="isdisplay" slot-scope="params">
        <MySwitch :data="params.params" :activeValue="`1`" :inactiveValue="`2`" @onToggle="toggleDisplay"></MySwitch>
      </template>
    </Table>

    <FormDialog ref="dialog" :title="title" :width="'548px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import systermMixin from "../mixin";

export default {
  mixins: [tableMixin, systermMixin],
  data() {
    return {
      baseUrl: 'cargoconfiguration',
      breadcrumb: [
        { name: "系统设置" },
        { name: "货物配置" },
      ],
      formCtrl: [
        {
          label: "货物名称",
          keyName: "name",
          placeholder: "请填写货物名称",
          type: "text",
        },
      ],
      cols: [
        { keyName: "name", label: "货物名称", minwidth: 120 },
        { keyName: "nickname", label: "创建人", minwidth: 120 },
        { keyName: "sort", label: "排序", minwidth: 120 },
        { keyName: "is_display", label: "是否显示", slot: 'isdisplay', minwidth: 120 },
        { keyName: "created_at", label: "添加时间", minwidth: 120 },
      ],
      title: '添加货物',
      mform: {},
      mrules: {
        name: [
          {
            required: true,
            message: '请填写货物名称',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "货物名称",
          keyName: "name",
          err: "请填写货物名称",
          type: "text",
        },
        {
          label: "排序",
          keyName: "sort",
          err: "请填写排序",
          type: "number",
          tips: "数字越小排序越靠前",
        },
        {
          label: "是否显示",
          keyName: "is_display",
          type: "radio",
          options: [
            { label: '是', value: 1 },
            { label: '否', value: 2 },
          ],
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped></style>
